module.exports = __webpack_public_path__ + "static/media/calendar-page.11ce4fc7.jpg";